module.exports = __webpack_public_path__ + "static/img/elect-gray.5c95a7c0.png";